import {createApp} from 'vue'
import App from './App'
import router from './router'


//Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap' 

//Element ui
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

//axios
import axios from 'axios'
import VueAxios from 'vue-axios'
axios.defaults.baseURL = '/socket'

//Vuex
import store from './vuex'


router.beforeEach(async(to,from,next)=>{
    if(to.path == '/login'){
        return next()
    }
    try {
        let data = await axios.post('/login_status', {path: to.path}) // Check login_status
        if(data.data["status"] == true){
            await store.commit("setUserData", data.data.data)
            await store.commit("setLogin", true)
        }
        else{
            await store.commit("setLogin", false)
        }
        if(!['/login', '/registration', '/Welcome'].includes(to.path)) {
            if(data.data["status"] == true){
                next()
            }else{
                if(to.path == '/login'){
                    next()
                }
                else{
                    next("/login")
                }
            }
        }
        else{
            next()
        }
    } catch (error) {
        await store.commit("setLogin", false)
        if(!['/login', '/registration', '/Welcome'].includes(to.path)) {
            next("/login");
        }else{
            next()
        }
        
    }
})

/* eslint-disable no-new */
const vm = createApp(App)
vm.use(router)
vm.use(store)
vm.use(ElementPlus)
vm.use(VueAxios, axios)
vm.mount('#app')

  
